/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateShiftCommand } from '../model'
// @ts-ignore
import type { ShiftResponseDto } from '../model'
// @ts-ignore
import type { UpdateShiftCommand } from '../model'
/**
 * ShiftsApi - axios parameter creator
 */
export const ShiftsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete: async (
      ids?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Shifts`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (ids) {
        localVarQueryParameter['ids'] = ids
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateShiftCommand} [createShiftCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createShiftCommand?: CreateShiftCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Shifts`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createShiftCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (query?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Shifts`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (query !== undefined) {
        for (const [key, value] of Object.entries(query)) {
          localVarQueryParameter[key] = value
        }
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateShiftCommand} [updateShiftCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      updateShiftCommand?: UpdateShiftCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Shifts`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateShiftCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ShiftsApi - functional programming interface
 */
export const ShiftsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ShiftsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      ids?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(ids, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ShiftsApi._delete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateShiftCommand} [createShiftCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createShiftCommand?: CreateShiftCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(createShiftCommand, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ShiftsApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      query?: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShiftResponseDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(query, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ShiftsApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateShiftCommand} [updateShiftCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      updateShiftCommand?: UpdateShiftCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateShiftCommand, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ShiftsApi.update']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ShiftsApi - factory interface
 */
export const ShiftsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ShiftsApiFp(configuration)
  return {
    /**
     *
     * @param {Array<number>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(ids?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp._delete(ids, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateShiftCommand} [createShiftCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createShiftCommand?: CreateShiftCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .create(createShiftCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {object} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(query?: object, options?: RawAxiosRequestConfig): AxiosPromise<Array<ShiftResponseDto>> {
      return localVarFp.get(query, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateShiftCommand} [updateShiftCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      updateShiftCommand?: UpdateShiftCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .update(updateShiftCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * ShiftsApi - object-oriented interface
 */
export class ShiftsApi extends BaseAPI {
  /**
   *
   * @param {Array<number>} [ids]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public _delete(ids?: Array<number>, options?: RawAxiosRequestConfig) {
    return ShiftsApiFp(this.configuration)
      ._delete(ids, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateShiftCommand} [createShiftCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(createShiftCommand?: CreateShiftCommand, options?: RawAxiosRequestConfig) {
    return ShiftsApiFp(this.configuration)
      .create(createShiftCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {object} [query]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(query?: object, options?: RawAxiosRequestConfig) {
    return ShiftsApiFp(this.configuration)
      .get(query, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateShiftCommand} [updateShiftCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public update(updateShiftCommand?: UpdateShiftCommand, options?: RawAxiosRequestConfig) {
    return ShiftsApiFp(this.configuration)
      .update(updateShiftCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
